/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getAgencies({ params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get("/agencies", { headers, params, signal });
}

export function createAgency({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.post("/agencies", payload, { headers });
}

export function getAgency({ agencyId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get(`/agencies/${agencyId}`, { headers, signal });
}

export function updateAgency({ agencyId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put(`/agencies/${agencyId}`, payload, { headers });
}

export function getAgencyMessagingProviders({ agencyId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get(`/agencies/${agencyId}/providers`, { headers, signal });
}

export function bindUserSessionToAgency({ sessionId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put(`/sessions/${sessionId}`, payload, { headers });
}

export function getAgencySettings({ agencyId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get(`/agencies/${agencyId}/settings`, { headers, signal });
}

export function updateAgencySettings({ agencyId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put(`/agencies/${agencyId}/settings`, payload, { headers });
}

export function getUsersAssignedToAgency({ agencyId, params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get(`/agencies/${agencyId}/users`, { headers, params, signal });
}

export function addUserToAgency({ agencyId, userId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put(`/agencies/${agencyId}/users/${userId}`, payload, { headers });
}

export function removeUserFromAgency({ agencyId, userId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.delete(`/agencies/${agencyId}/users/${userId}`, { headers });
}

export function getAgencyPositions({ params, signal }) {
  const agencyId = store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": agencyId,
  };

  return axios.get(`/agencies/${agencyId}/positions`, { headers, params, signal });
}

export function createAgencyPosition({ payload }) {
  const agencyId = store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": agencyId,
  };

  return axios.post(`/agencies/${agencyId}/positions`, payload, { headers });
}

export function getAgencyPosition({ positionId, signal }) {
  const agencyId = store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": agencyId,
  };

  return axios.get(`/agencies/${agencyId}/positions/${positionId}`, { headers, signal });
}

export function removeAgencyPosition({ positionId }) {
  const agencyId = store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": agencyId,
  };

  return axios.delete(`/agencies/${agencyId}/positions/${positionId}`, { headers });
}

export function updateAgencyPosition({ payload, positionId }) {
  const agencyId = store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": agencyId,
  };

  return axios.put(`/agencies/${agencyId}/positions/${positionId}`, payload, { headers });
}

export function assignPositionToUser({ userId, positionId }) {
  const agencyId = store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": agencyId,
  };

  return axios.put(`/agencies/${agencyId}/positions/${positionId}/assign/${userId}`, {}, { headers });
}

export function unassignUserFromPosition({ userId, positionId }) {
  const agencyId = store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": agencyId,
  };

  return axios.delete(`/agencies/${agencyId}/positions/${positionId}/assign/${userId}`, { headers });
}